import { render, staticRenderFns } from "./details-5g.vue?vue&type=template&id=765efe64&scoped=true"
import script from "./details-5g.vue?vue&type=script&lang=js"
export * from "./details-5g.vue?vue&type=script&lang=js"
import style0 from "./details-5g.vue?vue&type=style&index=0&id=765efe64&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "765efe64",
  null
  
)

export default component.exports